import React from 'react';
import DetailPage from '../../components/DetailPage';

export default function CloudServices() {
  return <DetailPage type="service" id="cloud-services" />;
}
